import httpClient from "@/api/httpClient";
import PlacePage from "@/model/PlacePage";
import PlaceRequest from "@/model/PlaceRequest";
import PlaceResponse from "@/model/PlaceResponse";

function listPlaces(
  accessToken: string,
  page: number,
  size: number
): Promise<PlacePage> {
  return httpClient.getJson<PlacePage>(
    `/api/places?page=${page}&size=${size}`,
    accessToken
  );
}

function getPlaceById(
  accessToken: string,
  id: string
): Promise<PlaceResponse> {
  return httpClient.getJson<PlaceResponse>(`/api/places/${id}`, accessToken);
}

function createPlace(
  accessToken: string,
  request: PlaceRequest
): Promise<PlaceResponse> {
  return httpClient.postJson<PlaceResponse>(
    "/api/places",
    request,
    accessToken
  );
}

function updatePlace(
  accessToken: string,
  id: string,
  request: PlaceRequest
): Promise<PlaceResponse> {
  return httpClient.putJsonBody<PlaceResponse>(
    `/api/places/${id}`,
    request,
    accessToken
  );
}

function deletePlace(accessToken: string, id: string): Promise<void> {
  return httpClient.deleteNoContent(`/api/places/${id}`, accessToken);
}

const placesApi = {
  listPlaces,
  getPlaceById,
  createPlace,
  updatePlace,
  deletePlace,
};

export default placesApi;
